// src/modules/moduleDashboards/components/ContextSelector.jsx
import React from 'react';
import { Card, Space, Select, Segmented, Button, Tag, Typography } from 'antd';
import { ReloadOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { scopesUpTo } from '../constants';

const { Text } = Typography;

// Context bar: choose data scope (Branch / Area / Global, limited to the user's
// maxScope) plus the branch or region the data is fetched for.
export default function ContextSelector({
  maxScope = 'BRANCH',
  scope, onScopeChange,
  branch, onBranchChange, branches = [],
  region, onRegionChange, regions = [],
  appliedLabel, loading, onRefresh,
  // When the viewer is not privileged (branch-scoped), lock to their own branch:
  // no scope switch, no branch dropdown — they can only ever see their branch.
  branchLocked = false,
}) {
  const allowed = scopesUpTo(maxScope);
  const showScopeSwitch = !branchLocked && allowed.length > 1;

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
        <Space wrap align="center">
          <Text strong><EnvironmentOutlined /> Data context:</Text>

          {showScopeSwitch ? (
            <Segmented
              value={scope}
              onChange={onScopeChange}
              options={allowed.map((s) => ({ label: s.label, value: s.value }))}
            />
          ) : (
            <Tag color="blue">{branchLocked ? 'My Branch' : (allowed[0]?.label || 'Branch')}</Tag>
          )}

          {!branchLocked && scope === 'BRANCH' && (
            <Select
              showSearch optionFilterProp="children" allowClear style={{ width: 220 }}
              placeholder="Branch" value={branch || undefined}
              onChange={(v) => onBranchChange(v || 'all')}
            >
              <Select.Option value="all">My / Default branch</Select.Option>
              {branches.map((b) => <Select.Option key={b._id} value={b._id}>{b.name}</Select.Option>)}
            </Select>
          )}

          {scope === 'AREA' && (
            <Select
              showSearch optionFilterProp="children" allowClear style={{ width: 220 }}
              placeholder="Select region / area" value={region || undefined}
              onChange={(v) => onRegionChange(v || null)}
            >
              {regions.map((r) => <Select.Option key={r} value={r}>{r}</Select.Option>)}
            </Select>
          )}

          {appliedLabel && <Tag color="geekblue">Showing: {appliedLabel}</Tag>}
        </Space>

        <Button icon={<ReloadOutlined />} onClick={onRefresh} loading={loading}>Refresh</Button>
      </Space>
    </Card>
  );
}
